import _ from 'lodash'
import { combineReducers } from 'redux'
//@ts-ignore no types
import { reducers } from '@adc/ui-morpheus'
import { COMMUNICATIONS } from '../../constants/tableTypes'
import { UPDATE_COMMUNICATIONS } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {}

const notificationReducer = (
  state = initialState,
  action: { type: string; communications?: unknown[] }
) => {
  switch (action.type) {
    case UPDATE_COMMUNICATIONS:
      return {
        ...state,
        content: action.communications,
      }
    default:
      return reducers.dataTable.tableFetchReducer(COMMUNICATIONS, state, action)
  }
}

export default combineReducers({
  data: notificationReducer,
  tableInfo: tableReducer,
})

export { initialState, notificationReducer }
